export default __webpack_public_path__ + "static/media/project-tutorial.467fd60d.png";